import { useState, useEffect } from "react";
import {
  Alert,
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { makeRequest } from "../apis/makeRequest";
import { getPresentaciones } from "../apis/backendRequests";

const styles = {
  tableHead: {
    backgroundColor: "#225533",
  },
  tableCell: {
    color: "white"
  },
  textField: {
    width: "50%",
  },
  inputTextField: {
    "& input": { color: "black", textAlign: "center" },
  },
  button: {
    color: "black",
    backgroundColor: "#B5CD7F",
    '&:hover': {
      backgroundColor: "#8BB85A",
    },
    "& .Mui-disabled": {
      backgroundColor: "grey",
    },
    width: "100%",
    boxShadow: "1px 1px 1px 1px gray"
  },
};

const TableUnit = ({ product, setterUnit, isEdit, submit }) => {
  const [variantes, setVariantes] = useState([]);
  const [unit, setUnit] = useState(isEdit || "");

  const changeValue = (e) => {
    const value = e.target.value
    setUnit(value)
    setterUnit(value)
  };

  useEffect(() => {
    if (!product) return;

    makeRequest(
      () => getPresentaciones(product.productId),
      (res) => setVariantes(res.data),
      null,
      { checkEmptyResults: false }
    );
  }, [product]);

  const sendValue = (e) => {
    e.preventDefault()
    if (unit && unit > 0) {
      submit()
    }
  }

  return (
    <form onSubmit={(e) => sendValue(e)}>
      <Stack spacing={1.5}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={styles.tableHead}>
              <TableRow>
                <TableCell style={styles.tableCell} align="center">Presentaciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {variantes.map((item, i) => {
                return (
                  <TableRow key={`${item.uofM}-${i}`}>
                    <TableCell align="center">{item.uofM}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>


        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={styles.tableHead}>
              <TableRow>
                <TableCell style={styles.tableCell} align="center" colSpan={2}>Ingrese Cantidad</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="center">
                  <TextField
                    size="small"
                    sx={styles.textField}
                    type="number"
                    onChange={changeValue}
                    value={unit}
                    InputProps={{
                      inputMode: "numeric",
                      placeholder: "0",
                      min: 0,
                      sx: styles.inputTextField,
                    }}
                  />
                </TableCell>
                <TableCell align="right">
                  <Button
                    sx={styles.button}
                    variant="contained"
                    disabledBackground={"grey"}
                    onClick={() => submit()}
                    disabled={!unit || unit <= 0}
                  >
                    Agregar
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </form>
  );
};

export default TableUnit;
